// info and warning are only printed in development mode

// error and info is always printed
const warningEnabled = process.env.REACT_APP_ENV !== "production";
const infoEnabled = process.env.REACT_APP_ENV !== "production";
const errorEnabled = true;

// print info to console in green.
function info(...args) {
  if (infoEnabled) {
    console.info(
      "\u001B[32m%s\u001B[0m",
      "<INFO>:",
      ...args.map((arg) => JSON.stringify(arg, null, 2))
    );
  }
}

// print warning to console in yellow.
// used for non-critical issues. Disabled in production mode
function warning(...args) {
  if (warningEnabled) {
    console.warn(
      "\u001B[33m%s\u001B[0m",
      "<WARNING>:",
      ...args.map((arg) => JSON.stringify(arg, null, 2))
    );
  }
}

// print error to console in red
// used for critical issues. Always enabled
function error(...args) {
  if (errorEnabled) {
    console.error(
      "\u001B[31m%s\u001B[0m",
      "<ERROR>:",
      ...args.map((arg) => JSON.stringify(arg, null, 2))
    );
  }
}

const log = { info, error, warning };

module.exports = { log, info, error, warning };
